import { useQuery } from '@tanstack/react-query'
import { http } from '@shared/libs/http'
import { SessionSchema, type Session } from '@api/schemas/auth'

const STATIC_KEY = 'capexia.static_auth'

function readStaticSession(): Session | null {
  try {
    const raw = localStorage.getItem(STATIC_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    const res = SessionSchema.safeParse(parsed)
    return res.success ? res.data : null
  } catch {
    return null
  }
}

const DISABLE_BACKEND = (import.meta.env as any).VITE_DISABLE_BACKEND === '1'

function anonymousSession(): Session {
  return {
    authenticated: false,
    needs_email_verify: false,
    needs_mfa: false,
    user: null,
    roles: [],
    permissions: []
  }
}

async function fetchSession(): Promise<Session> {
  const staticSession = readStaticSession()
  if (staticSession) return staticSession
  if (DISABLE_BACKEND) return anonymousSession()
  try {
    const { data } = await http.get('/auth/session')
    const parsed = SessionSchema.safeParse(data)
    if (!parsed.success) return anonymousSession()
    return parsed.data
  } catch {
    return anonymousSession()
  }
}

export function useSession() {
  return useQuery({ queryKey: ['session'], queryFn: fetchSession, staleTime: 30_000 })
}
